import React, { FC, useRef } from 'react';
import './App.css';
import { Box, Toolbar } from '@mui/material';
import { useOutlet } from 'react-router-dom';
import TransitionWrapper from './TransitionWrapper';
import { ScrollbarMargins } from './components/PerfectScrollbar/types';

const Content: FC = () => {
  const Outlet = useOutlet();

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
      <Toolbar />
      {/* <PerfectScrollbar scrollRef={scrollRef} margins={scrollMargins}> */}
      <TransitionWrapper>{Outlet}</TransitionWrapper>
      {/* </PerfectScrollbar> */}
    </Box>
  );
};

export default Content;
